<form [formGroup]="form">
  <h2 mat-dialog-title>Asignar conversación</h2>

  <mat-dialog-content>
    <p class="conversation-name">{{ data.conversation.display_name }}</p>

    <mat-button-toggle-group formControlName="target_type" class="target-toggle" aria-label="Tipo de asignación">
      <mat-button-toggle value="user">Usuario</mat-button-toggle>
      <mat-button-toggle value="company">Empresa</mat-button-toggle>
    </mat-button-toggle-group>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ target_type() === 'user' ? 'Buscar usuario' : 'Buscar empresa' }}</mat-label>
      <input
        matInput
        formControlName="search"
        [matAutocomplete]="assignAutocomplete"
        [placeholder]="target_type() === 'user' ? 'Nombre o email…' : 'Nombre de empresa…'"
      />
      @if (loading()) {
        <mat-spinner matSuffix diameter="18"></mat-spinner>
      }
      <mat-autocomplete #assignAutocomplete="matAutocomplete" [displayWith]="displayOption" (optionSelected)="onOptionSelected($event)">
        @for (option of options(); track option.id) {
          <mat-option [value]="option">
            <div class="option-label">{{ option.label }}</div>
            @if (option.subtitle) {
              <div class="option-subtitle">{{ option.subtitle }}</div>
            }
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" [disabled]="saving()">Cancelar</button>
    <button mat-flat-button color="primary" type="button" (click)="confirm()" [disabled]="selected_option() == null || saving()">
      {{ saving() ? 'Asignando…' : 'Asignar' }}
    </button>
  </mat-dialog-actions>
</form>
